import { Box, Typography } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { ClosedSymbolProps } from './types';

export default function ClosedSymbol(props: ClosedSymbolProps) {
    const {
        id,
        className
    } = props;

    const classes = muiStyles(props);

    return (
        <Typography
            className={`${classes.root} ${className}`}
            id={id}
            variant='h4'
        >
            <Box
                className={classes.text}
                data-testid='closed-symbol-value'
            >Closed
            </Box>
        </Typography>
    );
}